import styled, { css } from "styled-components";
import { cursorPointer, maxWidth, paddingLeftAndRight } from "../Layout";

type IconType = {
    margin: string;
}

type NavType = {
    backgroundColor: string;
    minHeight: "95vh" | "0"
    opacity: "0" | "1";
}
const displayFlexCenter = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SNav = styled.header<NavType>`
    width: 100%;
    ${displayFlexCenter}
    position: fixed;
    z-index: 100;
    top: 0;
    transition: all 0.7s cubic-bezier(0.165, 0.85, 0.45, 1);
    background-color: ${props => props.theme.colors.primary};

    div.header-box{
        width: 100%;
        height: 5rem;
        ${maxWidth};
        background-color: ${props => props.theme.colors.primary};
        transition: all 0.5s ease;
        ${paddingLeftAndRight}
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media screen and (max-width:850px) {
            max-width: 100%;
            border-radius: 0;
            padding: 0;
            background-color: ${props => props.backgroundColor};
        }
        div.picture{
            height: 100%;
            ${displayFlexCenter}
            @media screen and (max-width:850px) {
                padding-left: 1.5rem;
            }
            div{
                max-width: 3rem;
                max-height: 3rem;
                margin-right: 1rem;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            span{
                font-size: 1.125rem;
                color: ${props => props.theme.colors.white};
                max-width: 6rem;
                line-height: 1.2;
                font-weight:bold;
            }
        }

        nav{
            height: 100%;
            @media screen and (max-width:850px) {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                min-height: ${props => props.minHeight};
                top: 0;
                visibility:${props => props.minHeight === '0' ? 'hidden' : 'visible'};
                margin-top: 5rem;
                opacity: ${props => props.opacity};
                transition: opacity 0.35s cubic-bezier(0.165, 0.85, 0.45, 1);
                transition: min-height 0.7s cubic-bezier(0.165, 0.85, 0.45, 1);
                background-color: ${props => props.theme.colors.primary};
                
             }  
            ul {
                list-style-type: none;
                height: 100%;
                ${displayFlexCenter}
                @media screen and (max-width:850px) {
                    flex-direction: column;
                    justify-content: flex-start;
                    width: 100%;
                }
                li {
                    &:last-child{
                        @media screen and (max-width:850px) {
                           display: none;
                        }
                    }
                    @media screen and (max-width:850px) {
                        width: 100%;
                    }

                    &:not(:last-child){
                        a{
                            display: block;
                            color: ${props=>props.theme.colors.white};
                            text-align: center;
                            padding: 0.875rem 1rem;
                            text-decoration: none;
                            text-transform: uppercase;
                            font-size: 0.85rem;
                            font-weight: bold;
                            transition: all 0.2s ease;
                            @media screen and (max-width:850px) {
                                font-size: 1.25rem;
                            }
                            &:hover{
                                color: ${props => props.theme.colors.tertiary};
                            }

                            &.active{
                                color: ${props => props.theme.colors.tertiary};
                            }
                        }
                    }
                
                }
            }
        }

        button.menu-btn-mobile{
            display: none;
            width: 3rem;
            height: 60%;
            border-radius: 10rem;
            border: 1px solid ${props => props.theme.colors.white};
            background: transparent;
            transition: all 0.3s ease;
            color:${props => props.theme.colors.white};
            ${cursorPointer}
        
            
            @media screen and (max-width:850px) {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 1.5rem;
            }
        }
    }
`

export const Icon = styled.span<IconType>`
    margin: ${props => props.margin} ;
`

export const Div = styled.div<{ overflow: "hidden" | "visible" }>`
    position: relative;
    width: 100%;
    ${displayFlexCenter}
    overflow: ${props => props.overflow};
    transition: all 0.35s cubic-bezier(0.165, 0.85, 0.45, 1);
`
export const DivMenuHeight = styled.div`
        width: 100%;
        height: 5rem;
        background-color: transparent;
       
`

export const SocialNetwork = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    
    a{
        color: ${props=>props.theme.colors.white};
        display:flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        transition: all 0.2s ease;
        &:first-child{
            margin: 0 1rem;
        }

        &:hover{
            color: ${props=>props.theme.colors.tertiary};
        }
    }
    

`